
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaPlayGoogle as ObiMediaPlayGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-play-google.js';
 
 
 

 
 export const ObiMediaPlayGoogle = createComponent({
   react: React,
   tagName: 'obi-media-play-google',
   elementClass: ObiMediaPlayGoogleElement,
   events: {
     
   }
  });
 
 